/*
 * @Author: 魑魅魍魉鬼魃魈
 * @Description: 描述
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home'
import Support from '../views/home/support'
import Detail from '../views/detail'
import ResetPsw from '../views/resetpsw'
import Player from '../views/player'

const UserCenterIndex = () => import('../views/vi_userCenter/userCenterIndex.vue')
const Search = () => import('../views/vi_ searchList/searchListIndex.vue')

Vue.use(VueRouter)

// 跳转至'/game'的函数
let redirectToGame = to => {
  let { query } = to
  let { gindex } = query
  delete query.gindex
  delete query.version
  return { path: `/game/${gindex}`, query }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/support',
    name: 'support',
    component: Support
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: UserCenterIndex
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // },

  {
    path: '/mini_detail',
    redirect: redirectToGame
  },
  {
    path: '/detail',
    redirect: redirectToGame
  },
  {
    path: '/game',
    name: 'game',
    component: Detail,
    children: [
      {
        path: ':gindex'
      }
    ]
  },
  {
    path: '/resetpsw',
    name: 'resetpsw',
    component: ResetPsw
  },
  {
    path: '/player',
    name: 'player',
    component: Player
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
